import Text from '@/shared-components/text/components/Text';

import './styles/ArtworkViewOptions.css';

export default function OptionItem({ text, icon, onClick }) {
  return (
    <>
      <div className="artwork-options__artwork-option" onClick={onClick}>
        <Text className="artwork-options__artwork-option-text" small>
          {text}
        </Text>

        <div className="artwork-view-options">
          {icon}
        </div>
      </div>
    </>
  );
}
